import { Action } from '@ngrx/store'
import * as WardsTypes from './wards.types'
import { Ward } from './wards.interface'

// Fetch Ward Types
export class FetchWardsRequest implements Action {
  readonly type = WardsTypes.FETCH_WARDS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchWardsSuccess implements Action {
  readonly type = WardsTypes.FETCH_WARDS_SUCCESS
  constructor(
    public payload: Ward[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchWardsFailure implements Action {
  readonly type = WardsTypes.FETCH_WARDS_FAILURE
  constructor(public payload: any) {}
}

// Fetch Ward Type
export class FetchWardRequest implements Action {
  readonly type = WardsTypes.FETCH_WARD_REQUEST
  constructor(public id: number) {}
}

export class FetchWardSuccess implements Action {
  readonly type = WardsTypes.FETCH_WARD_SUCCESS
  constructor(public payload: Ward) {}
}

export class FetchWardFailure implements Action {
  readonly type = WardsTypes.FETCH_WARD_FAILURE
  constructor(public payload: any) {}
}

// Delete Ward Type
export class DeleteWardRequest implements Action {
  readonly type = WardsTypes.DELETE_WARD_REQUEST
  constructor(public id: number) {}
}

export class DeleteWardSuccess implements Action {
  readonly type = WardsTypes.DELETE_WARD_SUCCESS
  constructor() {}
}

export class DeleteWardFailure implements Action {
  readonly type = WardsTypes.DELETE_WARD_FAILURE
  constructor(public payload: any) {}
}

// Create Ward Type
export class CreateWardRequest implements Action {
  readonly type = WardsTypes.CREATE_WARD_REQUEST
  constructor(public payload) {}
}

export class CreateWardSuccess implements Action {
  readonly type = WardsTypes.CREATE_WARD_SUCCESS
  constructor() {}
}

export class CreateWardFailure implements Action {
  readonly type = WardsTypes.CREATE_WARD_FAILURE
  constructor(public payload: any) {}
}

// Update Ward Type
export class UpdateWardRequest implements Action {
  readonly type = WardsTypes.UPDATE_WARD_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateWardSuccess implements Action {
  readonly type = WardsTypes.UPDATE_WARD_SUCCESS
  constructor() {}
}

export class UpdateWardFailure implements Action {
  readonly type = WardsTypes.UPDATE_WARD_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = WardsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = WardsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateWardRequest
  | UpdateWardSuccess
  | UpdateWardFailure
  | FetchWardsSuccess
  | FetchWardsFailure
  | FetchWardsRequest
  | FetchWardSuccess
  | FetchWardFailure
  | FetchWardRequest
  | CreateWardRequest
  | CreateWardSuccess
  | CreateWardFailure
  | DeleteWardRequest
  | DeleteWardSuccess
  | DeleteWardFailure
  | SetDefaultData
  | UpdateField
  | FetchWardsRequest
  | FetchWardsSuccess
  | FetchWardsFailure
